import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=c5d93e2e"
import script from "./edit.ts?vue&type=script&lang=js&external"
export * from "./edit.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5d93e2e')) {
      api.createRecord('c5d93e2e', component.options)
    } else {
      api.reload('c5d93e2e', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=c5d93e2e", function () {
      api.rerender('c5d93e2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/configuracaofranquia/edit.vue"
export default component.exports